import { render, staticRenderFns } from "./OwnerCalculationGenerateForm.vue?vue&type=template&id=cb2ee96c&scoped=true&"
import script from "./OwnerCalculationGenerateForm.vue?vue&type=script&lang=js&"
export * from "./OwnerCalculationGenerateForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerCalculationGenerateForm.vue?vue&type=style&index=0&id=cb2ee96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2ee96c",
  null
  
)

export default component.exports